import {module} from 'angular';
import App from '../../../app';

class HeaderDirective {
	
	constructor(utilService, popupService, httpService, $scope){
		this.restrict = 'E';
		this.templateUrl = 'app/common/directive/header/header.html';
		this.scope = $scope;
		
		this.httpService = httpService;
		this.popupService = popupService;
		this.utilService = utilService;
	}
	
	controller($scope, $state, userService, utilService, popupService) {
		const user = userService.getUser();
		
		$scope.iconItems = [
			{
				icon: 'bxd bxd-my', label: user.userId, state: 'main.manageUser'
			}
		];
		
		
//		$scope.click = (item = {}) => {
//			console.log('click::');
//			if(item.state) {
//				$state.go(item.state);
//			}
//		};
		
		$scope.logout = () => {
			
			userService.requestLogout($scope);
			
			console.log('click logout :)');
		}
		
		$scope.setTheme = () => {
			console.log('click set theme :)');
		}

		$scope.manualDown = () => {
			console.log('click manual Download :)');
			
			userService.manualDown($scope);
		}
	}
	
	link($scope, $element, attrs) {
		
	}
}

module(App.name).directive('bcHeader', ()=> new HeaderDirective)


// WEBPACK FOOTER //
// ./src/app/common/directive/header/header.directive.js